import { Image } from '@chakra-ui/react'

export const SvgIcon = ({ icon, size, sx }) => {
  return <Image src={icon} width={size} height={size} sx={sx} />
}
